import React, { FC, PropsWithChildren } from 'react';
import { ChevronRightIcon } from '@lyse-as/formds-react/lib/icon/common';
import { Button } from '@lyse-as/formds-react';

import { StyledCard, StyledButtonContainer } from './card.styled';

interface CardProps {
  buttonText: string;
  onButtonClick: () => void;
  disabled?: boolean;
}

const Card: FC<PropsWithChildren<CardProps>> = (props) => {
  const { children, onButtonClick, buttonText, disabled, ...rest } = props;

  return (
    <StyledCard {...rest}>
      {children}
      <StyledButtonContainer>
        <Button onClick={onButtonClick} disabled={disabled}>
          {buttonText}
          <ChevronRightIcon />
        </Button>
      </StyledButtonContainer>
    </StyledCard>
  );
};

export { Card };
